import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useProductStore from "../../states/ProductStore";
import styles from "./OnlineStore.module.css";
import Page from "../../components/page/Page.jsx";
import Product from "../../components/product/Product.jsx";
function getProductImage(product) {
    const image = product?.image ?? product?.images?.[0] ?? product?.variants?.[0]?.images?.[0];

    if (typeof image === "string") {
        return {
            src: image,
            alt: product?.name || "Product image",
        };
    }

    return {
        src: image?.url || "",
        alt: image?.alt_text || product?.name || "Product image",
    };
}

function getProductPriceDisplay(product) {
    if (product?.pricing?.display) {
        return product.pricing.display;
    }

    const cents = product?.variants?.[0]?.effective_price_cents;

    if (typeof cents === "number") {
        return `$${(cents / 100).toFixed(2)}`;
    }

    return "Price unavailable";
}

function OnlineStore() {
    const navigate = useNavigate();
    const products = useProductStore((state) => state.products);

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, []);

    return (
        <Page
            title="Products"
            skinny={true}
            pageStyles={{
                title: { color: "var(--fg-muted)" }
            }}
        >
            <div className={styles.productList}>
                {products.map((product) => {
                    const image = getProductImage(product);
                    const optionCount = product?.active_variant_count ?? product?.variants?.length ?? 0;
                    const price = getProductPriceDisplay(product);

                    return (
                    <Product
                        key={product.id}
                        product={product}
                        image={image}
                        priceDisplay={price}
                        onClick={() => { console.log(product.id); navigate(`/products/${product.id}`); }}
                    />
                );})}
            </div>
        </Page>
    );
}

export default OnlineStore;